var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectedChallengesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.199 16.6316H3.21217V1.59211C3.21217 1.26497 2.9472 1 2.62007 1H1.43586C1.10872 1 0.84375 1.26497 0.84375 1.59211V17.8158C0.84375 18.4697 1.37405 19 2.02796 19H19.199C19.5262 19 19.7911 18.735 19.7911 18.4079V17.2237C19.7911 16.8965 19.5262 16.6316 19.199 16.6316ZM18.0148 4.07895H13.6458C12.8546 4.07895 12.4583 5.03557 13.0178 5.59511L14.2168 6.79412L11.5016 9.50966L8.78647 6.79449C8.32389 6.33191 7.57414 6.33191 7.11192 6.79449L4.56994 9.33647C4.33865 9.56776 4.33865 9.94264 4.56994 10.1739L5.40703 11.011C5.63832 11.2423 6.0132 11.2423 6.24449 11.011L7.94901 9.30613L10.6642 12.0213C11.1268 12.4839 11.8765 12.4839 12.3387 12.0213L15.8914 8.46867L17.0904 9.66768C17.6499 10.2272 18.6065 9.83088 18.6065 9.03968V4.67105C18.6069 4.34391 18.3419 4.07895 18.0148 4.07895Z",
    fill: "url(#paint0_linear_633_398)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_633_398",
    x1: 10.3174,
    y1: 1,
    x2: 10.3174,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4056DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3746A3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedChallengesIcon);
export default __webpack_public_path__ + "static/media/selectedChallengesIcon.f14887e067f1f6b354c6b927cfa64ee9.svg";
export { ForwardRef as ReactComponent };